import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  CardHeader, Card, CardBody,
} from 'reactstrap';

import moment from 'moment';

import BaseGrid from '../Common/BaseGrid';

function Stock(props) {
  const { t, entity } = props;

  const jsx = (
    <Card>
      <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Item Stock')}</CardHeader>
      <CardBody>
        <BaseGrid
          url="/api/items/stock"
          shouldPaginate={false}
          filters={`item_id=${entity.id}`}
          config={
          {
            columns: {
              source: {
                label: props.t('Source'),
                link: {
                  to: `/item/${entity.id}`,
                },
              },
              qty: {
                label: props.t('Qty'),
                sort: true,
              },
              cost: {
                label: props.t('Cost'),
                sort: true,
              },
              has_core: {
                label: props.t('Core'),
                format: (value) => (value ? props.t('Yes') : props.t('No')),
                sort: true,
              },
              last_report: {
                label: props.t('Reported'),
                date: {
                  format: (date) => (moment(date).fromNow()),
                  timezone: process.env.LOCAL_TZ,
                },
                sort: true,
              },
            },
            pagination: {
              sort: 'id',
              direction: 'desc',
              perPage: 30,
            },
          }
          }
        />
      </CardBody>
    </Card>
  );

  return jsx;
}

Stock.defaultProps = {
  entity: {},
};

Stock.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
};

export default connect(() => ({

}), {})(withTranslation()(Stock));
